import React from 'react'
import AllEvents from '../components/event/allEvents'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'


const AllEventsPage = () => {
    return (
        <>
            <Navbar />
            <AllEvents />
            <Footer />
        </>
    )
}

export default AllEventsPage